import React, { useEffect, useRef, useState } from "react";
import Attachments from "../../../components/Attachments/Attachments";
import Notifications from "../../../components/Notifications/Notifications";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useStateValue } from "../../../StateProvider";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import Select from 'react-select'

import {
  AcceptProject,
  AcceptTask,
  CancelProject,
  CancelTask,
  DoneTask,
  RejectProject,
  RejectSubTask,
  RejectTask,
  StartTask,
  addNewTask,
  addProject,
  checkSubtaskStatus,
  editeUser,
  getAddNewTaskDetail,
  getAddProjectData,
  getAllTaskTempList,
  getProject,
  getProjectTemp,
  getProjectTempList,
  getProjectTemplateDetail,
  getSignupReDetail,
  getTaskDetail,
  getTaskTempList,
  getTaskTemplateDetail,
  signup,
  updateProject,
  updateTaskDetail,
} from "../../../apiCall";
import { IoIosCloseCircle } from "react-icons/io";
import "./AddUpdateProject.scss";

import toast from "react-hot-toast";
import { convertToDateTimeLocalFormat, DateToYYYYMMDD, formatDateTimetoAmPm } from "../../../utils/FormateDate";
import { NewPasswordModal } from "../../../components/Modals/NewPasswordModal";
import { useNavigate, useParams } from "react-router-dom";
import SubTaskList from "../Components/ProjectTaskList";
import EncodeAprxDuration from "../../../utils/EncodeAprxDuration";
import { useQuery } from "@tanstack/react-query";
import DecodeAprxDuration from "../../../utils/DecodeAprxDuration";
import { ConfirmationModal } from "../../../components/Modals/ConfirmationModal";
import { isAdmin } from "../../../utils/adminAccess";
import { isCancel } from "axios";
import { getClassNamesOfDuration } from "../../../utils/colorCode";
import Attachment from "../../Attachment/Attachment";
import TaskList from "../Components/ProjectTaskList";
import ProjectTaskList from "../Components/ProjectTaskList";
import Notification from "../../Notification/Notification/Notification";
import calculateEndDate from "../../../utils/calculateEndDate";
import { convertToOptions, convertToUserOptions, customStyles } from "../../../utils/ConvertToOptions";
import { ConfirmationReasonModal } from "../../../components/Modals/ConfirmationResonModal";
import { validateNoBlankSpaces } from "../../../utils/formValidation";
const formatDateTime = (datetimeString) => {
  const date = new Date(datetimeString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};
const isDate1GreterThenDate2 = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  if (d1 > d2) {
    return true;
  } else {
    return false;
  }
};


const calculateDifference = (startString, endString) => {
  const startDate = new Date(startString.replace(" ", "T"));
  const endDate = new Date(endString.replace(" ", "T"));

  const diffMilliseconds = endDate - startDate;

  const diffSeconds = Math.floor(diffMilliseconds / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  const hours = diffHours % 24;
  const minutes = diffMinutes % 60;

  return {
    days: diffDays,
    hours: hours,
    minutes: minutes,
  };
};

const AddUpdateProject = () => {
  const [tab, setTab] = useState("information");
  const [{ userInfo }, dispatch] = useStateValue();
  const [profileImage, setSetProfileImage] = useState("");
  const [profileError, setProfileError] = useState(false);
  const [projectStatus, setProjectStatus] = useState("Pending");
  const [isSaveAndAddTask, setIsSaveAndAddTask] = useState(false);
  const [isSaveAndEditeSubtask, setIsSaveAndEditeSubtask] = useState(false);
  const [editTaskId, setEditTaskId] = useState();
  const [isDoneAction, setIsDoneAction] = useState(false);
  const [isCancelProjectAction, setIsCancelProjectAction] = useState(false);
  const [isStartAction, setIsStartAction] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [closingComment, setClosingComment] = useState("");
  const [delayReason, setDelayReason] = useState("");
  const [commentCount, setCommentCount] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userFilter = searchParams.get("project_user_filter"); // Replace 'param1' with your parameter name
  const statusFilter = searchParams.get("project_status_filter");
  const searchFilter = encodeURIComponent(searchParams.get("project_search_filter"));
  const [title, setTitle] = useState("Add Project");
  const [tranMID, setTranMID] = useState();
  const { projectId } = useParams();

  // # attachmentCount **************************************************
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [isAddAttachments, setIsAddAttachments] = useState(false);
  const [isAddNotification, setIsAddNotification] = useState(false);
  // # attachmentCount **************************************************

  const navigate = useNavigate();
  const updateUrl = (newPath) => {
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);

    // Construct new URL
    // const newPath = '/update/task/31';
    const newUrl = `${newPath}?${searchParams.toString()}`;

    // Navigate to the new URL
    navigate(newUrl);
  };

  const navigateToProjectWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/project?project_id=${Id}&project_status_filter=${statusFilter}&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/project?project_id=${Id}&project_status_filter=${statusFilter}&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/project?project_id=${Id}&project_status_filter=All&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else {
      navigate(
        `/project?project_id=${Id}&project_status_filter=All&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    }
  };
  const navigateToProject = () => {
    if (statusFilter && userFilter) {
      navigate(
        `/project?project_status_filter=${statusFilter}&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/project?project_status_filter=${statusFilter}&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/project?project_status_filter=All&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else {
      navigate(
        `/project?project_status_filter=All&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    }
  };
  const navigateToSubTaskWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/update/subtask/${Id}?project_status_filter=${statusFilter}&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/update/subtask/${Id}?project_status_filter=${statusFilter}&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/update/subtask/${Id}?project_status_filter=All&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else {
      navigate(
        `/update/subtask/${Id}?project_status_filter=All&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    }
  };
  const navigateToAddTaskWithId = (Id) => {
    if (statusFilter && userFilter) {
      navigate(
        `/add/task/${Id}?project_status_filter=${statusFilter}&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else if (statusFilter) {
      navigate(
        `/add/task/${Id}?project_status_filter=${statusFilter}&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    } else if (userFilter) {
      navigate(
        `/add/task/${Id}?project_status_filter=All&project_user_filter=${userFilter}&project_search_filter=${searchFilter}`
      );
    } else {
      navigate(
        `/add/task/${Id}?project_status_filter=All&project_user_filter=All&project_search_filter=${searchFilter}`
      );
    }
  };

  const startTask = async (id) => {
    const re = await StartTask(id);
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToProjectWithId(id);
      // navigate(`/task?projectId=${id}`);
      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  // const doneTask = async (id, reason) => {
  //   const re = await DoneTask(id, { DelayReason: reason });
  //   if (re?.status === 200) {
  //     toast.success(re?.data?.message);
  //     navigateToProjectWithId(id);

  //     // navigate(`/task?projectId=${id}`);

  //     // taskDetailRefetch();
  //   } else {
  //     toast.error(re?.response?.data?.message);
  //   }
  // };
  const acceptProject = async (id, reason, DelayReason) => {
    let data = { ClosingComment: reason }
    if (DelayReason) {
      data = { ClosingComment: reason, DelayReason: DelayReason }
    }
    const re = await AcceptProject(id, data);
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToProjectWithId(id);

      // navigate(`/task?projectId=${id}`);

      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const rejectProject = async (id, reason) => {
    const re = await RejectProject(id, { RejectReason: reason });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToProjectWithId(id);

      // navigate(`/task?projectId=${id}`);

      // taskDetailRefetch();
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };
  const cancelProject = async (id, reson) => {
    const re = await CancelProject(id, { CancReason: reson });
    if (re?.status === 200) {
      toast.success(re?.data?.message);
      navigateToProjectWithId(id);

      // navigate(`/task?projectId=${id}`);
    } else if (re?.response) {
      toast.error(re?.response?.data?.message);
    }
  };

  const transformedArray = (inputArray) => {
    if (inputArray) {
      const output = inputArray.map((obj) => {
        const key = Object.keys(obj)[0];
        const value = obj[key];
        return { id: key, value: value };
      });
      return output;
    }
    return [];
  };
  const imageRef = useRef();

  // ********************************************** handle image change start ****************************************************
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        // Once the file is read, set the Base64 string
        setValue("Photo", reader.result);
        setSetProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };
  // ********************************************** handle image change end ****************************************************

  // ********************************************** form start ****************************************************
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      AprxDays: 0,
      AprxHours: 0,
      AprxMinutes: 0,
      ActualDays: 0,
      ActualHours: 0,
      ActualMinutes: 0,
      // AllocBy: "SysAdm",
      // Country: "India",
    },
  });
  const watchedFields = watch();
  const onSubmit = async (data) => {
    if (
      parseInt(data?.AprxDays) === 0 &&
      parseInt(data?.AprxMinutes) === 0 &&
      parseInt(data?.AprxHours) === 0
    ) {
      toast.error("Days, hours and minutes cannot be 0.");
    } else {
      // **************************** formate dates start ****************************
      if (data.EndDtTm > data.StartDtTm) {
        data.StartDtTm = formatDateTime(data.StartDtTm);
        data.EndDtTm = formatDateTime(data.EndDtTm);
        delete data.ActualStDtTm;
        delete data.ActualEndDtTm;
        if (data?.planned_duration) {
          delete data.planned_duration;
        }

        // **************************** formate dates end ****************************
        // **************************** convert duration start ****************************
        const totalAprxDays = EncodeAprxDuration(
          data?.AprxDays === "" ? 0 : data?.AprxDays,
          data?.AprxHours === "" ? 0 : data?.AprxHours,
          data?.AprxMinutes === "" ? 0 : data?.AprxMinutes
        );
        data.Duration = totalAprxDays;
        delete data.AprxDays;
        delete data.AprxHours;
        delete data.AprxMinutes;

        delete data.ActualDays;
        delete data.ActualHours;
        delete data.ActualMinutes;
        // **************************** convert duration end ****************************

        dispatch({ type: "SET_LOADING", status: true });
        try {
          let re;
          if (projectId) {
            re = await updateProject(projectId, data);
            // console.log(isAddAttachments,"isAddAttachmentsisAddAttachmentsisAddAttachmentsisAddAttachmentsisAddAttachments")

            if (re?.status === 200) {
              if (isSaveAndEditeSubtask) {
                setIsSaveAndEditeSubtask(false);
                navigateToSubTaskWithId(editTaskId);
                // navigate(`/update/subtask/${editSubTaskId}`);
                reset();
                toast.success(re?.data?.message);
              } else {
                if (isSaveAndAddTask) {
                  setIsSaveAndAddTask(false);
                  navigateToAddTaskWithId(projectId);
                  // navigate(`/add/subtask/${projectId}`);
                  reset();
                  toast.success(re?.data?.message);
                } else if (isStartAction) {
                  handleConfirmationShow();
                  setFunHandler({
                    fun: startTask,
                    id: projectId,
                    title: "start task.",
                  });
                  setIsStartAction(false);
                }
                // else if (isDoneAction) {
                //   const re = await checkSubtaskStatus(projectId);
                //   console.log(re);
                //   if (re?.status === 200) {
                //     handleConfirmationResonShow();
                //     const specificDateTime = new Date(watchedFields.EndDtTm);

                //     // Step 2: Get the current date and time
                //     const currentDateTime = new Date();
                //     setFunHandler({
                //       fun: doneTask,
                //       id: projectId,
                //       isGetReason: currentDateTime > specificDateTime,
                //       lable: "Delay task reason",

                //       title: "change task status to done",
                //     });
                //     setIsDoneAction(false);
                //   } else {
                //     toast.error(re.response.data.message);
                //   }
                // }
                else if (isCancelProjectAction) {
                  handleConfirmationResonShow();
                  setFunHandler({
                    fun: cancelProject,
                    id: projectId,
                    isGetReason: true,
                    lable: "Cancel project reason",
                    title: "cancel project",
                  });
                  setIsCancelProjectAction(false);
                } else if (isAddAttachments) {
                  // updateUrl(`/update/task/${projectId}`);
                  setTab("attachments");
                  // setTitle("Attachment List");
                  setTitle(projectId ? "Update Project" : "Add Project");

                  setIsAddAttachments(false);
                } else if (isAddNotification) {
                  setTab("notifications");
                  setTitle(projectId ? "Update Project" : "Add Project");
                  setIsAddNotification(false);
                } else {
                  navigateToProjectWithId(projectId);

                  // navigate(`/task?projectId=${projectId}`);
                  reset();
                  toast.success(re?.data?.message);
                }
              }
            } else if (re?.response) {
              toast.error(re?.response?.data?.message);
            }
          } else {
            re = await addProject(data, selectedProjectTempId);
            if (re?.status === 201) {
              reset();

              if (isSaveAndAddTask) {
                if (selectedProjectTempId) {
                  navigateToProjectWithId(re?.data?.data?.ID);

                  // navigate(`/task?projectId=${re?.data?.data?.ID}`);
                } else {
                  navigateToAddTaskWithId(re?.data?.data?.ID);
                  // navigate(`/add/subtask/${re?.data?.data?.ID}`);
                }
              } else if (isAddAttachments) {
                updateUrl(`/update/project/${re?.data?.data?.ID}`);
                setTab("attachments");
                setTitle(projectId ? "Update Project" : "Add Project");
                setIsAddAttachments(false);
              } else if (isAddNotification) {
                updateUrl(`/update/project/${re?.data?.data?.ID}`);
                setTab("notifications");
                setTitle(projectId ? "Update Project" : "Add Project");
                setIsAddNotification(false);
              } else {
                navigateToProjectWithId(re?.data?.data?.ID);

                // navigate(`/task?projectId=${re?.data?.data?.ID}`);
              }

              toast.success(re?.data?.message);
            } else if (re?.response) {
              toast.error(re?.response?.data?.message);
            }
          }
        } catch { }
        dispatch({ type: "SET_LOADING", status: false });
        // } else {
        //   setProfileError(true);
      } else {
        toast.error("End Date must be more than Start Date.");
      }
    }
  };
  // ********************************************** form end ****************************************************
  // // ********************************************** calculate end date ****************************************************
  const onDateOrDurationChange = (value, type) => {

    if (type === "startDate") {
      if (
        (watchedFields.AprxDays ||
          watchedFields.AprxHours ||
          watchedFields.AprxMinutes) &&
        value
      ) {
        const endDate = calculateEndDate(
          value,
          watchedFields.AprxDays,
          watchedFields.AprxHours,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "day") {
      if (
        (value || watchedFields.AprxHours || watchedFields.AprxMinutes) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          value,
          watchedFields.AprxHours,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "hours") {
      if (
        (watchedFields.AprxDays || value || watchedFields.AprxMinutes) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          watchedFields.AprxDays,
          value,
          watchedFields.AprxMinutes
        );

        setValue("EndDtTm", endDate);
      }
    } else if (type === "minutes") {
      if (
        (watchedFields.AprxDays || watchedFields.AprxHours || value) &&
        watchedFields.StartDtTm
      ) {
        const endDate = calculateEndDate(
          watchedFields.StartDtTm,
          watchedFields.AprxDays,
          watchedFields.AprxHours,
          value
        );

        setValue("EndDtTm", endDate);
      }
    }

  };
  // ********************************************** remove image end ****************************************************
  const [show, setShow] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const handleClose = () => {
    setShow(false);
    setNewPassword("");
  };
  const handleShow = () => setShow(true);
  // ********************************************** get data start ****************************************************
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["new-project-form-data"],
    queryFn: async () => {
      // Perform the API call to fetch company info
      dispatch({ type: "SET_LOADING", status: true });
      try {
        const response = await getAddProjectData();
        if (response?.status === 200) {
          setFormDefaultData(response.data.data);
          if (!projectId) {
            setValue("Priority", "1");
          }
        } else if (response?.response) {
          toast.error(response.response.data.status);
        }

        // return response;
      } catch (error) {
        console.error("Error fetching data:", error); // Log any errors that occur
      }
      dispatch({ type: "SET_LOADING", status: false });
    },
  });
  const [formDefaultData, setFormDefaultData] = useState(
    data?.status === 200 ? data.data.data : {}
  );
  const [priorityOption, setPriorityOption] = useState(
    data?.status === 200 ? data.data.data?.priority_list : []
  );
  const [leadOption, setLeadOption] = useState(
    data?.status === 200 ? data.data.data : []
  );
  // ********************************************** get data end ****************************************************
  // ********************************************** get task data start****************************************************
  const fetchProject = async () => {
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });
    try {
      const response = await getProject(projectId);

      if (response?.status === 200) {
        // setTaskTempList(response.data.data);
        // setCommentCount(0)
        if (commentCount === 0) {
          let count = 0
          console.log("RRRRRRRRRRRRRRRRrr", response, response.data?.CancReason)
          if (response.data?.CancReason) {
            setCancelReason(response.data?.CancReason);
            count += 1
            setCommentCount(count);
          }
          if (response.data?.RejectReason) {
            setRejectionReason(response.data?.RejectReason);
            count += 1
            setCommentCount(count);
          }
          if (response.data?.DelayReason) {
            setDelayReason(response.data?.DelayReason);
            count += 1
            setCommentCount(count);
          }
          if (response.data?.ClosingComment) {
            setClosingComment(response.data?.ClosingComment);
            count += 1
            setCommentCount(count);
          }
        }
        setAttachmentCount(response.data?.attachments_no);
        setNotificationCount(response.data?.notifications?.unread);

        setValue("ID", response.data?.ID);
        setValue("OrdNo", response.data?.OrdNo);
        setValue("Name", response.data?.Name);
        setValue("Dscr", response.data?.Dscr);
        setValue("ProjLead", response.data?.ProjLead);
        setValue("Status", response.data?.Status?.idx);
        setProjectStatus(response.data?.Status?.text);
        setValue("Priority", response.data?.Priority);
        setValue("AllocBy", response.data?.AllocBy);
        const [days, hours, minutes] = DecodeAprxDuration(
          response?.data?.Duration
        );
        setValue("planned_duration", response?.data?.planned_duration);
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
        const [ActualDays, ActualHours, ActualMinutes] = DecodeAprxDuration(
          response?.data?.actual_duration
        );
        setValue("ActualDays", ActualDays);
        setValue("ActualHours", ActualHours);
        setValue("ActualMinutes", ActualMinutes);
        setValue(
          "StartDtTm",
          convertToDateTimeLocalFormat(response?.data?.StartDtTm)
        );
        setValue(
          "EndDtTm",
          convertToDateTimeLocalFormat(response?.data?.EndDtTm)
        );
        if (response?.data?.ActualStDtTm) {
          setValue(
            "ActualStDtTm",
            response?.data?.ActualStDtTm
          );
        }
        if (response?.data?.ActualEndDtTm) {
          setValue(
            "ActualEndDtTm",
            response?.data?.ActualEndDtTm
          );
        }
        // setValue("AprxDays", days);
        // setValue("AprxHours", hours);
        // setValue("AprxMinutes", minutes);
      } else if (response?.response) {
        toast.error(response.response.data.message);
      }

      return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  const { data: taskTempDetail, refetch: projetDetailRefetch } = useQuery({
    queryKey: ["project-detail"],
    queryFn: fetchProject,
    enabled: projectId ? true : false,
    // staleTime: Infinity,
    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });
  // ********************************************** get task data end ****************************************************

  useEffect(() => {
    if (!projectId) {
      setValue("Priority", "1");
      setValue("AllocBy", userInfo?.user_code);
      setValue("ProjLead", userInfo?.user_code);
    }
  }, [setValue, userInfo, projectId]);

  useEffect(() => {
    if (projectId && tab === "information") {
      setTitle("Update Project");
    }
    if (!projectId && tab === "information") {
      setTitle("Add Project");
    }
    setTranMID(projectId);
  }, [projectId]);

  const [funHandler, setFunHandler] = useState();
  const [confirmationShow, setConfirmationShow] = useState(false);
  const handleConfirmationClose = () => {
    setConfirmationShow(false);
  };
  const handleConfirmationShow = () => setConfirmationShow(true);
  const [confirmationResonShow, setConfirmationResonShow] = useState(false);
  const handleConfirmationResonClose = () => {
    setConfirmationResonShow(false);
  };
  const handleConfirmationResonShow = () => setConfirmationResonShow(true);

  // *********************************************** task temp list fetch ************************************************
  const fetchProjectTemp = async () => {
    // Perform the API call to fetch company info
    try {
      const response = await getProjectTempList();
      if (response?.status === 200) {
        setTaskTempList(response.data.data);
      } else if (response?.response) {
        toast.error(response?.response?.data?.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      throw error;
    }
  };
  const {
    isLoading: taskTempLoading,
    isFetching,
    data: projectTempListData,
    refetch: taskTempRefetch,
  } = useQuery({
    queryKey: ["project-temp-list"],
    enabled: !projectId ? true : false,

    queryFn: () => fetchProjectTemp(),

    onSuccess: (Re) => {
      console.log(Re);
    },
    onError: (e) => {
      console.log(e);
    },
  });

  const [taskTempList, setTaskTempList] = useState(
    projectTempListData?.status === 200 ? projectTempListData?.data?.data : []
  );
  const [selectedProjectTempId, setSelectedProjectTempId] = useState();
  const [selectedProjectTempOption, setSelectedProjectTempOption] = useState();

  const fetchProjectTempDetail = async (option) => {
    const proId = option.value
    setSelectedProjectTempOption(option)
    setSelectedProjectTempId(proId);
    // Perform the API call to fetch company info
    dispatch({ type: "SET_LOADING", status: true });
    try {
      const response = await getProjectTemplateDetail(proId);
      if (response?.status === 200) {
        if (response.data?.ProjTmplID) {
          // setValue("OrdNo", response.data?.OrdNo);
        }
        setValue("Name", response.data?.Name);

        setValue("Dscr", response.data?.Dscr);
        const [days, hours, minutes] = DecodeAprxDuration(
          response?.data?.AprxDuration
        );
        setValue("AprxDays", days);
        setValue("AprxHours", hours);
        setValue("AprxMinutes", minutes);
      } else if (response?.response) {
        toast.error(response.response.data.message);
      }

      // return response;
    } catch (error) {
      console.error("Error fetching data:", error); // Log any errors that occur
      // throw error;
      // return error;
    }
    dispatch({ type: "SET_LOADING", status: false });
  };
  const [getTaskFromTemp, setGetTaskFromTemp] = useState(false);
  const formRef = useRef(null);

  const handleExternalSubmit = (submitType) => {
    if (projectStatus === "Done" || projectStatus === "Cancelled" || projectStatus === "Pending Review") {
      setTab(submitType);
      setTitle(projectId ? "Update Project" : "Add Project");
    } else {
      if (tab === "information") {
        if (submitType === "attachments") {
          setIsAddAttachments(true);
        } else {
          setIsAddNotification(true);
        }
        if (formRef.current) {
          setTimeout(() => {
            formRef.current.dispatchEvent(
              new Event("submit", { cancelable: true, bubbles: true })
            );
          }, 100);
        }
      } else if (submitType === "attachments") {
        setTab("attachments");
        setTitle(projectId ? "Update Project" : "Add Project");
      } else {
        setTab("notifications");
        setTitle(projectId ? "Update Project" : "Add Project");
      }
    }
  };
  return (
    <div id="app-content">
      {/* Container fluid */}
      <div className="app-content-area mb-10">
        <div className="container-fluid ">
          <div className=" mx-n6 mt-n6 pt-6 mb-6 header">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                {/* Page header */}
                <div
                  className="d-lg-flex
          align-items-center justify-content-between  px-6"
                >
                  {/* <div className="mb-6 mb-lg-0"> */}
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <div className="">
                      <h1 className="mb-0 h3 ">{title}</h1>
                    </div>
                    <div lassName="status ">
                      <div
                        className="mb-0"
                        style={{ fontSize: "20px", fontWeight: "bold" }}
                      >
                        {projectStatus}
                      </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex justify-content-between px-6">
                  {/* nav  */}
                  <ul className="nav nav-lb-tab ">
                    <li className="nav-item ms-0 me-3">
                      <div
                        role="button"
                        // className="nav-link active "
                        className={`${tab === "information"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("information");
                          setTitle(
                            projectId ? "Update Project" : "Add Project"
                          );
                        }}
                      >
                        Information
                      </div>
                    </li>
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "attachments"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          handleExternalSubmit("attachments");
                        }}
                      // onClick={() => setTab("attachments")}
                      >
                        Attachments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {attachmentCount}
                      </div>
                    </li>
                    {console.log(tab)}
                    <li className="rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "notifications"
                          ? "nav-link active "
                          : "nav-link"
                          }`}
                        onClick={() => {
                          handleExternalSubmit("notifications");
                        }}
                      >
                        Notifications
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {notificationCount}
                      </div>
                    </li>
                    <li className=" rounded-circl notification-count nav-item mx-3">
                      <div
                        role="button"
                        className={`${tab === "comments" ? "nav-link active " : "nav-link"
                          }`}
                        onClick={() => {
                          setTab("comments");
                          setTitle(
                            projectId ? "Update Project" : "Add Project"
                          );
                        }}
                      >
                        Comments
                      </div>
                      <div
                        className="notification-count d-flex justify-content-center"
                        style={{ top: "3px", right: "-14px" }}
                      >
                        {commentCount}
                      </div>
                    </li>
                  </ul>
                  {/* <div className="status fs-3">
                    <h3>{taskStatus}</h3>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              {/* Page header */}
              {/* <div className="mb-5">
                <h3 className="mb-0 ">Add Staff</h3>
              </div> */}
            </div>
          </div>
          <div>
            {/* row */}
            <div className="row">
              <div className="col-xl-12 col-md-12 col-12">
                {/* card */}
                {(() => {
                  switch (tab) {
                    case "information":
                      return (
                        // <form onSubmit={handleSubmit(onSubmit)}>
                        <form onSubmit={handleSubmit(onSubmit)} ref={formRef}>
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body" style={{ padding: "10px" }}>
                              {/* form */}
                              <div className="row">
                                {/* form group */}
                                {!projectId && (
                                  <div className="mb-4 col-md-12 col-12 d-flex align-items-end">
                                    <label
                                      className=" pe-3"
                                      htmlFor="flexSwitchStock"
                                    >
                                      <strong>
                                        Add Project from Project Template
                                      </strong>
                                    </label>
                                    <div className="form-check form-switch d-flex justify-content-center align-items-center ">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="flexSwitchStock"
                                        checked={getTaskFromTemp}
                                        onClick={(e) => {
                                          if (e.target.checked) {
                                            setGetTaskFromTemp(true);
                                          } else {
                                            setSelectedProjectTempId("");
                                            setSelectedProjectTempOption({});

                                            setGetTaskFromTemp(false);
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                                {/* form group */}
                                {!projectId && (
                                  <div className="mb-4 col-md-12 col-12">
                                    <label className="form-label">
                                      Project Template
                                    </label>
                                    {/* <select
                                      className="form-select"
                                      disabled={!getTaskFromTemp}
                                      value={selectedProjectTempId}
                                      onChange={(e) => {
                                        if (e.target.value !== "") {
                                          fetchProjectTempDetail(
                                            e.target.value
                                          );
                                        }
                                      }}
                                    >
                                      <option value="">
                                        Select Project Tempate
                                      </option>
                                      {taskTempList?.map((item) => (
                                        <option value={item.ID}>
                                          {item?.Name}{" "}
                                        </option>
                                      ))}
                                    </select> */}
                                    <Select
                                      // className="form-select"
                                      styles={customStyles}
                                      isDisabled={!getTaskFromTemp}
                                      value={selectedProjectTempOption}
                                      placeholder="Select Template."
                                      onChange={(option) => {
                                        console.log(option)
                                        if (option.value !== "") {
                                          fetchProjectTempDetail(option);
                                        }
                                      }}
                                      options={[{ label: "Select a template", value: "", isDisabled: true }, ...convertToOptions(taskTempList, "Name", "ID")]} />
                                  </div>
                                )}
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Name
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="d-flex ">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Enter name"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          projectStatus === "Pending"
                                        )
                                      }
                                      {...register("Name", {
                                        required: "Name is required",
                                        validate: validateNoBlankSpaces,
                                      })}
                                    />
                                    <div className="ps-1 m-auto">
                                      {" "}
                                      <strong>
                                        {projectId ? projectId : "ID"}
                                      </strong>
                                    </div>
                                  </div>
                                  {errors.Name && (
                                    <div className="error">
                                      {errors.Name.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-12 col-12">
                                  <label className="form-label">
                                    Description{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <textarea
                                    type="text"
                                    rows={5}
                                    className="form-control"
                                    placeholder="Enter Description"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        projectStatus === "Pending"
                                      )
                                    }
                                    {...register("Dscr", {
                                      required: "description is required",
                                      validate: validateNoBlankSpaces,
                                    })}
                                  ></textarea>
                                  {errors.Dscr && (
                                    <div className="error">
                                      {errors.Dscr.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Lead
                                    <span className="text-danger">*</span>
                                  </label>
                                  {/* <select
                                    value={watchedFields.ProjLead}
                                    className="form-select"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        projectStatus === "Pending"
                                      )
                                    }
                                    {...register("ProjLead", {
                                      required: "Lead is required",
                                    })}
                                  >
                                    <option value="">Set Lead</option>
                                    {(formDefaultData?.users_list
                                      ? !formDefaultData?.users_list.includes(
                                        watchedFields.ProjLead
                                      )
                                      : false) && (
                                        <option value={watchedFields.ProjLead}>
                                          {" "}
                                          {watchedFields.ProjLead}
                                        </option>
                                      )}
                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select> */}
                                  <Select
                                    value={{ value: watchedFields.ProjLead, label: watchedFields.ProjLead }}
                                    styles={customStyles}
                                    isDisabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        projectStatus === "Pending"
                                      )
                                    }
                                    {...register("ProjLead", {
                                      required: "Lead is required",
                                    })}
                                    placeholder="Select Staff."

                                    onChange={(option) => {
                                      if (option.value !== "") {
                                        setValue("ProjLead", option.value)
                                      }
                                    }}
                                    options={(formDefaultData?.users_list ? !formDefaultData?.users_list.includes(
                                      watchedFields.ProjLead
                                    )
                                      : false) ? [{ label: "Select a user", value: "", isDisabled: true }, ...convertToUserOptions(formDefaultData?.users_list), { value: watchedFields.ProjLead, label: watchedFields.ProjLead }] : [{ label: "Select a user", value: "", isDisabled: true }, ...convertToUserOptions(formDefaultData?.users_list)]}
                                  />

                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Allocate By
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    value={watchedFields.AllocBy}
                                    disabled
                                    // disabled={
                                    //   !(
                                    //     isAdmin(userInfo) &&
                                    //     projectStatus === "Pending"
                                    //   )
                                    // }
                                    className="form-select"
                                    {...register("AllocBy", {
                                      required: "AllocBy is required",
                                    })}
                                  >
                                    <option value="">Set Allocate By</option>
                                    {(formDefaultData?.users_list
                                      ? !formDefaultData?.users_list.includes(
                                        watchedFields.AllocBy
                                      )
                                      : false) && (
                                        <option value={watchedFields.AllocBy}>
                                          {" "}
                                          {watchedFields.AllocBy}
                                        </option>
                                      )}
                                    {formDefaultData?.users_list?.map(
                                      (item) => (
                                        <option value={item}>{item}</option>
                                      )
                                    )}
                                  </select>
                                  {/* <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Allocate By."
                                    disabled
                                    {...register("AllocBy", {
                                      // required: "Approx Days is required",
                                    })}
                                  /> */}

                                  {errors.AllocBy && (
                                    <div className="error">
                                      {errors.AllocBy.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Priority
                                    <span className="text-danger">*</span>
                                  </label>

                                  <select
                                    className="form-select"
                                    value={watchedFields.Priority}
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        (projectStatus === "Pending" ||
                                          projectStatus === "In Process")
                                      )
                                    }
                                    {...register("Priority", {
                                      required: "Priority is required",
                                    })}
                                  >
                                    <option value="">Set Priority</option>

                                    {transformedArray(
                                      formDefaultData?.priority_list
                                    )?.map((item) => (
                                      <option value={item.id}>
                                        {item.value}
                                      </option>
                                    ))}
                                  </select>
                                  {errors.Priority && (
                                    <div className="error">
                                      {errors.Priority.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Days{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Days"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          projectStatus === "Done" ||
                                          projectStatus === "Cancelled" ||
                                          projectStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxDays", {
                                      required: "Approx Days is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "day"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxDays && (
                                    <div className="error">
                                      {errors.AprxDays.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6">
                                  <label className="form-label">
                                    Approx Hours{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Hours"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          projectStatus === "Done" ||
                                          projectStatus === "Cancelled" ||
                                          projectStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxHours", {
                                      max: {
                                        value: 23,
                                        message:
                                          "approx hours must be less than 24",
                                      },
                                      required: "Approx Hours is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "hours"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxHours && (
                                    <div className="error">
                                      {errors.AprxHours.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-4 col-6 ">
                                  <label className="form-label">
                                    Approx Minutes{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    className="form-control"
                                    placeholder="Enter Minutes"
                                    disabled={
                                      !(
                                        (userInfo?.user_code ===
                                          watchedFields.AllocBy ||
                                          isAdmin(userInfo)) &&
                                        !(
                                          projectStatus === "Done" ||
                                          projectStatus === "Cancelled" ||
                                          projectStatus === "Pending Review"
                                        )
                                      )
                                    }
                                    {...register("AprxMinutes", {
                                      max: {
                                        value: 59,
                                        message:
                                          "approx minutes must be less than 60",
                                      },
                                      required: "Approx Minutes is required",
                                      onChange: (e) => {
                                        onDateOrDurationChange(
                                          e.target.value,
                                          "minutes"
                                        );
                                      },
                                    })}
                                  />
                                  {errors.AprxMinutes && (
                                    <div className="error">
                                      {errors.AprxMinutes.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Planned Start{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          projectStatus === "Pending"
                                        )
                                      }
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("StartDtTm", {
                                        required: "Start Date is required",
                                        onChange: (e) => {
                                          onDateOrDurationChange(
                                            e.target.value,
                                            "startDate"
                                          );
                                        },
                                      })}
                                    />
                                  </div>
                                  {errors.StartDtTm && (
                                    <div className="error">
                                      {errors.StartDtTm.message}
                                    </div>
                                  )}
                                </div>
                                {/* form group */}
                                <div className="mb-4 col-md-6 col-12">
                                  <label className="form-label">
                                    Planned End{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      disabled={
                                        !(
                                          (userInfo?.user_code ===
                                            watchedFields.AllocBy ||
                                            isAdmin(userInfo)) &&
                                          (projectStatus === "Pending" ||
                                            projectStatus === "In Process")
                                        )
                                      }
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      {...register("EndDtTm", {
                                        required: "End Date is required",

                                      })}
                                    />
                                  </div>
                                  {errors.EndDtTm && (
                                    <div className="error">
                                      {errors.EndDtTm.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className=" col-md-6 col-12 d-flex justify-content-lg-start justify-content-md-start justify-content-start">
                                  <label className="form-label d-flex " style={{ marginBottom: "0px" }}>
                                    {/* Actual Start{" "} */}
                                    {/* <span className="text-danger">*</span> */}
                                    <div className="fw-normal " style={{ width: "83px" }}>
                                      Actual Start{" "}

                                    </div>
                                    :{" "}{formatDateTimetoAmPm(watchedFields?.ActualStDtTm)}
                                  </label>
                                  {/* <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      disabled
                                      {...register("ActualStDtTm", {
                                      })}
                                    />
                                  </div> */}
                                  {errors.ActualStDtTm && (
                                    <div className="error">
                                      {errors.ActualStDtTm.message}
                                    </div>
                                  )}
                                </div>

                                {/* form group */}
                                <div className="mb-2 col-md-6 col-12 d-flex justify-content-lg-end justify-content-md-end justify-content-start">
                                  <label className="form-label d-flex">
                                    <div className="fw-normal" style={{ width: "83px" }}>
                                      Actual End
                                    </div>
                                    :{" "}{formatDateTimetoAmPm(watchedFields?.ActualEndDtTm)}
                                  </label>
                                  {/* <div
                                    className="input-group me-3 flatpickr rounded flatpickr-input"
                                    readOnly="readonly"
                                  >
                                    <input
                                      className="form-control "
                                      type="datetime-local"
                                      placeholder="Select Date"
                                      aria-describedby="basic-addon2"
                                      min="1000-01-01T00:00"
                                      max="9999-12-31T23:59"
                                      disabled
                                      {...register("ActualEndDtTm", {
                                      })}
                                    />
                                  </div> */}
                                  {errors.ActualEndDtTm && (
                                    <div className="error">
                                      {errors.ActualEndDtTm.message}
                                    </div>
                                  )}
                                </div>

                                {(isAdmin(userInfo) || userInfo?.user_code === watchedFields.AllocBy) &&
                                  (
                                    projectStatus === "Pending" ||
                                    projectStatus === "In Process"
                                  ) &&
                                  projectId && (
                                    <div className="d-flex justify-content-end   gap-4 ">
                                      <div
                                        className="  rounded-circl notification-count col-lg-2 col-md-4 col-12 mb-4"
                                        style={{ width: "300px" }}
                                      >

                                        <button
                                          // className="btn btn-outline-danger me-2"
                                          className={`btn  btn-outline-danger w-100  `}
                                          onClick={() =>
                                            setIsCancelProjectAction(true)
                                          }
                                        >
                                          Cancel Project
                                        </button>
                                      </div>

                                    </div>
                                  )}

                              </div>
                            </div>
                            {/* form group */}
                            <div className=" col-md-12 col-12">
                              <label className="form-label" style={{ margin: "0px" }}>
                                <h3 style={{ margin: "0px", paddingLeft: "20px" }}>
                                  Tasks{" "}
                                  <span className="text-danger">*</span>
                                </h3>
                              </label>
                              <ProjectTaskList
                                setIsSaveAndAddTask={setIsSaveAndAddTask}
                                setIsSaveAndEditeSubtask={
                                  setIsSaveAndEditeSubtask
                                }
                                setEditTaskId={setEditTaskId}
                                watchedFields={watchedFields}
                                projectStatus={projectStatus}
                              />
                            </div>
                          </div>
                          <div className="mt-4 mb-4  flex-wrap justify-content-between gap-4 bottom-btns-mobile">
                            {isAdmin(userInfo) &&
                              projectStatus === "Pending Review" &&
                              projectId &&
                              <div className="left d-flex  gap-3 align-items-center justify-content-between w-100">
                                <div
                                  className="  rounded-circl notification-count"
                                  style={{ width: "80.63px" }}
                                >
                                  {
                                    isAdmin(userInfo) &&
                                    projectStatus === "Pending Review" &&
                                    projectId && (
                                      <div
                                        // className="btn btn-outline-danger me-2"
                                        className={`btn  btn-outline-danger w-100   ${!(
                                          isAdmin(userInfo) &&
                                          projectStatus === "Pending Review" &&
                                          projectId
                                        )
                                          ? "disabled"
                                          : ""
                                          }`}
                                        // onClick={() => rejectTask(projectId)}
                                        disabled={
                                          !(
                                            isAdmin(userInfo) &&
                                            projectStatus === "Pending Review" &&
                                            projectId
                                          )
                                        }
                                        onClick={() => {
                                          handleConfirmationResonShow();
                                          setFunHandler({
                                            fun: rejectProject,
                                            id: projectId,
                                            isGetReason: true,
                                            lable: "Rejection comment",
                                            title: "reject task.",
                                          });
                                        }}
                                      >
                                        Reject
                                      </div>
                                    )}
                                  {/* <div className="notification-count">24</div> */}
                                </div>
                                {isAdmin(userInfo) &&
                                  projectStatus === "Pending Review" &&
                                  projectId && (
                                    <div
                                      className="  rounded-circl notification-count "
                                      style={{ width: "80.63px" }}
                                    >

                                      <div
                                        className={`btn btn-success w-100  ${!(
                                          isAdmin(userInfo) &&
                                          projectStatus === "Pending Review" &&
                                          projectId
                                        )
                                          ? "disabled"
                                          : ""
                                          }`}
                                        // onClick={() => acceptTask(projectId)}
                                        // disabled={!( isAdmin(userInfo) &&  projectStatus === "Pending Review" && projectId)}

                                        onClick={() => {
                                          handleConfirmationResonShow();
                                          setFunHandler({
                                            fun: acceptProject,
                                            id: projectId,
                                            isGetReason: true,
                                            endDateTime: watchedFields.EndDtTm,
                                            lable: "Closing comment",
                                            title: "accept task.",
                                          });
                                        }}
                                      >
                                        Accept
                                      </div>

                                    </div>
                                  )}
                                {/* <div className="notification-count">24</div> */}
                              </div>
                            }

                            <div className="d-flex right align-items-center gap-3 justify-content-between w-100">
                              <div
                                className="btn btn-outline-danger "
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  if (projectId) {
                                    navigateToProjectWithId(projectId);
                                    // navigate(`/task?projectId=${projectId}`);
                                  } else {
                                    navigateToProject();
                                    // navigate("/task");
                                  }
                                }}
                              >
                                Cancel
                              </div>
                              <button
                                className="  btn btn-primary  "
                                disabled={
                                  projectId
                                    ? !(
                                      (projectStatus === "Pending" ||
                                        projectStatus === "In Process") &&
                                      (userInfo?.user_code ===
                                        watchedFields.AllocBy ||
                                        userInfo?.user_code ===
                                        watchedFields.ProjLead ||
                                        isAdmin(userInfo))
                                    )
                                    : false
                                }
                              // disabled={
                              //   !(
                              //     (taskStatus === "Pending" ||
                              //       taskStatus === "In Process") &&
                              //     userInfo?.user_code ===
                              //       watchedFields.AllocBy &&
                              //     projectId
                              //   )
                              // }
                              >
                                Save
                              </button>
                            </div>
                          </div>
                          <div className="mt-4 mb-4  justify-content-between gap-4   bottom-btns-web">
                            <div className="left d-flex flex-wrap gap-3 align-items-center">
                              <div
                                className="btn btn-outline-danger "
                                style={{ height: "fit-content" }}
                                onClick={() => {
                                  if (projectId) {
                                    navigateToProjectWithId(projectId);
                                    // navigate(`/task?projectId=${projectId}`);
                                  } else {
                                    navigateToProject();
                                    // navigate("/task");
                                  }
                                }}
                              >
                                Cancel
                              </div>
                            </div>
                            {/* {taskStatus === "Pending Review" && projectId && ( */}
                            <div className="center d-flex flex-wrap gap-4 justify-content-center">
                              <div
                                className="  rounded-circl notification-count"
                                style={{ width: "80.63px" }}
                              >
                                {isAdmin(userInfo) &&
                                  projectStatus === "Pending Review" &&
                                  projectId && (
                                    <div
                                      // className="btn btn-outline-danger me-2"
                                      className={`btn  btn-outline-danger w-100   ${!(
                                        isAdmin(userInfo) &&
                                        projectStatus === "Pending Review" &&
                                        projectId
                                      )
                                        ? "disabled"
                                        : ""
                                        }`}
                                      // onClick={() => rejectTask(projectId)}
                                      disabled={
                                        !(
                                          isAdmin(userInfo) &&
                                          projectStatus === "Pending Review" &&
                                          projectId
                                        )
                                      }
                                      onClick={() => {
                                        handleConfirmationResonShow();
                                        setFunHandler({
                                          fun: rejectProject,
                                          id: projectId,
                                          isGetReason: true,
                                          lable: "Rejection comment",
                                          title: "reject Project.",
                                        });
                                      }}
                                    >
                                      Reject
                                    </div>
                                  )}
                                {/* <div className="notification-count">24</div> */}
                              </div>
                              <div
                                className="  rounded-circl notification-count "
                                style={{ width: "80.63px" }}
                              >
                                {isAdmin(userInfo) &&
                                  projectStatus === "Pending Review" &&
                                  projectId && (
                                    <div
                                      className={`btn btn-success w-100  ${!(
                                        isAdmin(userInfo) &&
                                        projectStatus === "Pending Review" &&
                                        projectId
                                      )
                                        ? "disabled"
                                        : ""
                                        }`}
                                      // onClick={() => acceptTask(projectId)}
                                      // disabled={!( isAdmin(userInfo) &&  taskStatus === "Pending Review" && projectId)}

                                      onClick={() => {
                                        handleConfirmationResonShow();
                                        setFunHandler({
                                          fun: acceptProject,
                                          id: projectId,
                                          isGetReason: true,
                                          endDateTime: watchedFields?.EndDtTm,
                                          lable: "Closing comment",
                                          title: "accept Project.",
                                        });
                                      }}
                                    >
                                      Accept
                                    </div>
                                  )}
                                {/* <div className="notification-count">24</div> */}
                              </div>
                            </div>
                            {/* // )} */}
                            <div className="d-flex right align-items-center">
                              <button
                                className="  btn btn-primary  "
                                disabled={
                                  projectId
                                    ? !(
                                      (projectStatus === "Pending" ||
                                        projectStatus === "In Process") &&
                                      (userInfo?.user_code ===
                                        watchedFields.AllocBy ||
                                        userInfo?.user_code ===
                                        watchedFields.ProjLead ||
                                        isAdmin(userInfo))
                                    )
                                    : false
                                }
                              // disabled={
                              //   !(
                              //     (taskStatus === "Pending" ||
                              //       taskStatus === "In Process") &&
                              //     userInfo?.user_code ===
                              //       watchedFields.AllocBy &&
                              //     projectId
                              //   )
                              // }
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      );
                    case "attachments":
                      return (
                        <Attachment
                          setTab={setTab}
                          setAttachmentCount={setAttachmentCount}
                          setTitle={setTitle}
                          attachmentType={"project"}
                          TranType={6}
                          AttchType={1}
                        ></Attachment>
                      );
                    case "notifications":
                      return (
                        <Notification
                          isStaffNotification={false}
                          setNotificationCount={setNotificationCount}
                          TranType={6}
                          TranMID={tranMID}
                          ProjectAllocBy={watchedFields.AllocBy}
                          ProjectLead={watchedFields.ProjLead}
                          detailRefetch={projetDetailRefetch}
                          setTitle={setTitle}
                          setTab={setTab}
                        ></Notification>
                      );
                    case "comments":
                      return (
                        <div className="w-100">
                          <div className="card mb-5">
                            {/* card body */}
                            <div className="card-body">
                              {/* form group */}

                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Closing Comment{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={closingComment}
                                  className="form-control"
                                  // placeholder="Comment..."
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Delay Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={delayReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Rejection Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={rejectionReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>
                              <div className="mb-4 col-md-12 col-12">
                                <label className="form-label">
                                  Cancel Reason{" "}
                                </label>
                                <textarea
                                  type="text"
                                  rows={5}
                                  value={cancelReason}
                                  className="form-control"
                                  // placeholder="Enter Description"
                                  disabled
                                ></textarea>
                                {errors.Dscr && (
                                  <div className="error">
                                    {errors.Dscr.message}
                                  </div>
                                )}
                              </div>

                              {/* </div> */}
                              <div className="right d-flex flex-wrap gap-3 align-items-center justify-content-end ">
                                <div
                                  className="btn btn-outline-danger  col-md-2 col-12 "
                                  style={{ height: "fit-content" }}
                                  onClick={() => {
                                    setTab("information")
                                    // if (projectId) {
                                    //   navigateToProjectWithId(projectId);
                                    //   // navigate(`/task?projectId=${projectId}`);
                                    // } else {
                                    //   navigateToProject();
                                    //   // navigate("/task");
                                    // }
                                  }}
                                >
                                  Back
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );

                    default:
                  }
                })()}
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewPasswordModal
        show={show}
        onHide={handleClose}
        newPassword={newPassword}
        title="Initial Password"
      />
      <ConfirmationModal
        show={confirmationShow}
        onHide={handleConfirmationClose}
        funHandler={funHandler}
      />
      <ConfirmationReasonModal
        show={confirmationResonShow}
        onHide={handleConfirmationResonClose}
        funHandler={funHandler}
      />
    </div>
  );
};

export default AddUpdateProject;
